import { TONE_CLASSES, type Tone } from "./tokens";
import { notifications, type NotificationStore } from "./notification-store";

const CONTAINER_ID = "cc-toast-container";

export function ensureToastContainer(): HTMLElement {
  const existing = document.getElementById(CONTAINER_ID);
  if (existing) return existing;
  const c = document.createElement("div");
  c.id = CONTAINER_ID;
  c.className = "fixed right-4 top-4 z-50 flex w-80 max-w-[90vw] flex-col gap-2";
  c.setAttribute("aria-live", "polite");
  document.body.append(c);
  return c;
}

export interface ToastInput {
  readonly tone: Tone;
  readonly title: string;
  readonly message?: string;
  readonly durationMs?: number;
  readonly store?: NotificationStore; // 既定: 共有 notifications
  readonly notify?: boolean; // 既定 true: ベルにも積む
}

// 右上トースト。既定で通知ストアにも積み、ベルの未読に反映(連動)。
export function showToast(input: ToastInput): void {
  const container = ensureToastContainer();
  const toast = document.createElement("div");
  toast.setAttribute("role", "status");
  toast.dataset["testid"] = "toast";
  toast.className = "cursor-pointer rounded-lg border bg-white p-3 shadow-md " + TONE_CLASSES[input.tone].bar;

  const title = document.createElement("p");
  title.className = "text-sm font-medium";
  title.textContent = input.title;
  toast.append(title);

  if (input.message !== undefined) {
    const m = document.createElement("p");
    m.className = "mt-0.5 text-xs";
    m.textContent = input.message;
    toast.append(m);
  }

  container.append(toast);
  const remove = (): void => toast.remove();
  toast.addEventListener("click", remove);
  setTimeout(remove, input.durationMs ?? 5000);

  if (input.notify !== false) {
    const store = input.store ?? notifications;
    store.add({
      tone: input.tone,
      title: input.title,
      ...(input.message !== undefined ? { message: input.message } : {}),
    });
  }
}
